module.exports = __webpack_public_path__ + "static/img/1059.d28eac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1059.jpg
// module id = 241
// module chunks = 0